import React from 'react';

interface OCAPIIntegrationIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const OCAPIIntegrationIcon: React.FC<OCAPIIntegrationIconProps> = ({ 
  width = 24, 
  height = 24, 
  className 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1941_35403)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.55078 2.36462C2.55078 0.932978 3.71032 -0.226562 5.14196 -0.226562H24.8577C26.2894 -0.226562 27.4489 0.932978 27.4489 2.36462V15.8558C27.4489 17.2875 26.2894 18.447 24.8577 18.447H17.6977L18.6492 21.1058H20.3351C20.6889 21.1058 21.0282 21.2463 21.2783 21.4965C21.5284 21.7466 21.669 22.0859 21.669 22.4396C21.669 22.7934 21.5284 23.1326 21.2783 23.3828C21.0282 23.6329 20.6889 23.7734 20.3351 23.7734H9.66453C9.31077 23.7734 8.97151 23.6329 8.72137 23.3828C8.47123 23.1326 8.3307 22.7934 8.3307 22.4396C8.3307 22.0859 8.47123 21.7466 8.72137 21.4965C8.97151 21.2463 9.31077 21.1058 9.66453 21.1058H11.3505L12.3019 18.447H5.14196C4.45474 18.447 3.79566 18.174 3.30972 17.6881C2.82378 17.2021 2.55078 16.5431 2.55078 15.8558V2.36462ZM12.3855 5.49467C12.5095 5.61854 12.6078 5.76561 12.6749 5.9275C12.742 6.08938 12.7765 6.2629 12.7765 6.43813C12.7765 6.61336 12.742 6.78688 12.6749 6.94876C12.6078 7.11064 12.5095 7.25772 12.3855 7.38159L10.6605 9.10667L12.3855 10.8318C12.6211 11.0846 12.7494 11.419 12.7433 11.7646C12.7372 12.1101 12.5972 12.4398 12.3529 12.6842C12.1085 12.9286 11.7788 13.0686 11.4332 13.0747C11.0877 13.0808 10.7532 12.9525 10.5004 12.7169L7.83274 10.0492C7.58296 9.79915 7.44266 9.46014 7.44266 9.10667C7.44266 8.75321 7.58296 8.41419 7.83274 8.1641L10.5004 5.49645C10.7505 5.24666 11.0895 5.10636 11.443 5.10636C11.7964 5.10636 12.1354 5.24489 12.3855 5.49467ZM19.4993 5.49645C19.2476 5.25359 18.9106 5.11931 18.5609 5.12251C18.2112 5.12571 17.8767 5.26615 17.6295 5.51357C17.3823 5.76099 17.2422 6.0956 17.2393 6.44533C17.2364 6.79505 17.3711 7.13192 17.6141 7.38337L19.3392 9.10845L17.6141 10.8335C17.3785 11.0864 17.2503 11.4208 17.2564 11.7664C17.2625 12.1119 17.4024 12.4416 17.6468 12.686C17.8912 12.9304 18.2209 13.0704 18.5665 13.0765C18.912 13.0826 19.2464 12.9543 19.4993 12.7187L22.1669 10.051C22.4167 9.80093 22.557 9.46192 22.557 9.10845C22.557 8.75498 22.4167 8.41597 22.1669 8.16588L19.4993 5.49645Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1941_35403">
          <rect width="30" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

